module.exports = __webpack_public_path__ + "img/7_PRODUCT_APPROVALS.e3d31c93.png";